import { SPACING } from '@alto/design-library-tokens';
import { Body, H1, LgPadding, Link, SteppedProgressBar, XsSpacing, XxxlPadding } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React from 'react';
import { getProgynyProgressBarProps } from '../helpers/getProgynyProgressBarProps';

type Props = {
  readonly headline: string;
  readonly subheadline?: string | React.ReactElement<typeof Body>;
  readonly linkCopy?: string;
  readonly linkOnPress?: () => void;
};
export const ProgynyWizardStepsHeaderContent = ({ headline, subheadline, linkCopy, linkOnPress }: Props) => {
  const { getCurrentRouteName } = useNavigation();
  const currentRoute = getCurrentRouteName();
  const progressBarProps = getProgynyProgressBarProps(currentRoute);

  return (
    <>
      <XsSpacing />
      <XxxlPadding
        topPadding={SPACING.STATIC.MD}
        bottomPadding={SPACING.STATIC.MD}
      >
        <SteppedProgressBar {...progressBarProps} />
      </XxxlPadding>
      <LgPadding topPadding={SPACING.STATIC.MD}>
        <H1>{headline}</H1>
        <XsSpacing />
        <Body>{subheadline}</Body>
        {linkCopy ? (
          <>
            <XsSpacing />
            <Link
              textSize="mini"
              onPress={linkOnPress}
            >
              {linkCopy}
            </Link>
          </>
        ) : null}
      </LgPadding>
    </>
  );
};
